import { AlertProps, Alert as MuiAlert, Snackbar as MuiSnackbar } from "@mui/material";
import './styles.css'
import { forwardRef, useContext } from "react";
import { contextSnack } from "../../context";


const AlertCustomized = forwardRef<HTMLDivElement, AlertProps>(function Alert(
	props,
	ref,
) {
	return <MuiAlert elevation={6} ref={ref} {...props} />;
});

export function Snackbar() {
	const { open, message, setOpen, severity } = useContext(contextSnack)

	const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
		if (reason === 'clickaway') {
			return;
		}
		setOpen(false);
	};

	return (
		<MuiSnackbar anchorOrigin={{ horizontal: "right", vertical: "top" }} open={open} autoHideDuration={6000} onClose={handleClose}>
			<AlertCustomized onClose={handleClose} severity={severity} sx={{ width: '100%' }}>
				{message}
			</AlertCustomized>
		</MuiSnackbar>
	);
}